<template>
  <v-alert v-model="value.active" class="alert" outlined :color="value.color">
    <SvgIcon :name="alertIcon" :color="value.color" class="alert__icon-left" />
    <div class="alert__content">
      <div class="subtitle-2 gray90--text">
        {{ value.title || $t("toast.success") }}
      </div>
      <div class="caption gray90--text">{{ value.message }}</div>
    </div>
    <SvgIcon
      name="remove"
      color="gray90"
      class="alert__icon-right"
      @click="$emit('close')"
    />
  </v-alert>
</template>
<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class TheAlert extends Vue {
  @Prop(Object) value: any;

  get alertIcon(): string {
    // Retorna o ícone do value ou um ícone padrão baseado na cor
    if (this.value?.icon) {
      return this.value.icon;
    }
    // Ícone padrão baseado na cor do alerta
    if (this.value?.color === "redAlert") {
      return "cancel";
    }
    if (this.value?.color === "green100") {
      return "confirm";
    }
    // Ícone padrão genérico
    return "confirm";
  }
}
</script>
<style lang="sass">
.alert
  right: 1.5rem
  position: fixed !important
  z-index: 1002 !important
  border: solid !important
  border-width: 1px 4px 1px 4px !important
  border-radius: 8px !important
  width: 340px !important
  min-height: 72px !important
  height: auto !important
  padding: 16px !important
  margin: 16px
  background: white !important
  @media(max-width: 600px)
    margin: 0
    bottom: 105px
    z-index: 999
    left:0
    right:0
    margin-left: auto
    margin-right: auto

.v-alert__content
  display: flex !important
  align-items: center !important
  gap: 16px !important
  width: 100%

.alert__content
  flex: 1
  display: flex
  flex-direction: column
  gap: 4px
  text-align: left

.alert__icon-left,
.alert__icon-right
  flex-shrink: 0 !important

.alert__icon-right
  margin-left: auto !important
  cursor: pointer
</style>
